/**
 * メール確認 / OAuth 後に戻ってくる先。
 *
 * この URL を明示しないと Supabase は Site URL のルートへ戻し、`AuthCallbackPage`
 * を通らないため `ensureOnboardedAndLogin()` が実行されず、サインアップやメール
 * アドレス変更が完了しない（Issue #106）。
 *
 * パスは React Router の `/auth/callback` と Supabase の Redirect URLs 許可リストの
 * 両方に一致している必要があるため、1 箇所に集約する。
 */
export function authCallbackUrl(): string {
  return `${window.location.origin}/auth/callback`
}

/**
 * Supabase が戻り先に付けた失敗の理由（error_code、無ければ error）。成功なら null。
 * 認可コード方式ではクエリ、implicit 方式ではハッシュに付くので両方を見る。
 */
export function readAuthRedirectError(search: string, hash: string): string | null {
  for (const raw of [search, hash]) {
    const params = new URLSearchParams(raw.replace(/^[?#]/, ''))
    const code = params.get('error_code') ?? params.get('error')
    if (code) return code
  }
  return null
}
